import Component from "@base/js/component";

export default class CountryGrid extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".country-grid";

  // Defines children that needs to be queried as part of this component
  static children = {
    images: [".country-grid__flag img"],
  };

  afterInit() {
    const { images } = this.children;

    // Add Flag to Alt text if not exists
    if (images.length > 0) {
      images.forEach((el) => {
        if (!el.alt.toString().toLowerCase().includes("flag")) {
          el.alt += " Flag";
        }
      });
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
CountryGrid.init();
